import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import GroupsIcon from '@mui/icons-material/Groups';

/**
 * Brand gradient badge with the Groups icon. Single source shared by the
 * employee list banner and the detail sub-header, so both stay identical.
 * Sizing comes from theme tokens (avatar / border-radius / icon size).
 */
export function EmployeeHeaderIcon() {
  return (
    <Box
      sx={theme => ({
        width: theme.avatar.md,
        height: theme.avatar.md,
        borderRadius: theme.borderRadius.md,
        background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.35)}`,
        flexShrink: 0,
      })}
    >
      <GroupsIcon
        sx={theme => ({ color: theme.palette.common.white, fontSize: theme.iconSize.md })}
      />
    </Box>
  );
}
